import { Dispatch } from "redux";
import axios from "../../helpers/axios";
import {
  CLEAR_POSTS,
  CLEAR_CURRENT_POST,
  FETCH_CATEGORIES_SUCCESS,
  FETCH_POST_FAILURE,
  FETCH_POST_REQUEST,
  FETCH_POST_SUCCESS,
  FETCH_POSTS_FAILURE,
  FETCH_POSTS_REQUEST,
  FETCH_POSTS_SUCCESS,
  SAVE_POST_FAILURE,
  SAVE_POST_REQUEST,
  SAVE_POST_SUCCESS,
  FETCH_CATEGORIES_FAILURE,
  FETCH_CATEGORIES_REQUEST,
} from "../constants/postConstants";
import { IPost } from "../../types/postsTypes";

export const fetchPosts =
  (page = 0, size = 5, category: string | null = null, search: string = "", reset = false, sortBy: string = "latest") =>
  async (dispatch: Dispatch) => {
    dispatch({ type: FETCH_POSTS_REQUEST });

    try {
      let url = `/posts/?page=${page}&size=${size}`;
      if (category) {
        url += `&category=${encodeURIComponent(category)}`;
      }
      if (search) {
        url += `&search=${encodeURIComponent(search)}`;
      }
      if (sortBy && sortBy !== "latest") {
        url += `&sortBy=${encodeURIComponent(sortBy)}`;
      }

      const { data } = await axios.get(url);
      dispatch({
        type: FETCH_POSTS_SUCCESS,
        payload: { posts: data.content, totalPages: data.totalPages, reset },
      });
    } catch (error) {
      console.log(error);
      dispatch({
        type: FETCH_POSTS_FAILURE,
        payload: "Error fetching posts",
      });
    }
  };

export const addCategory =
  (categoryName: string) => async (dispatch: Dispatch) => {
    try {
      const { data } = await axios.post("/category/", { name: categoryName });

      dispatch({ type: "ADD_CATEGORY_SUCCESS", payload: data });
    } catch (error) {
      dispatch({
        type: "ADD_CATEGORY_FAILURE",
        payload: "Failed to add category",
      });
    }
  };

export const fetchPost = (postId: string) => async (dispatch: Dispatch) => {
  dispatch({ type: FETCH_POST_REQUEST });

  try {
    const { data } = await axios.get(`/posts/${postId}`);
    dispatch({ type: FETCH_POST_SUCCESS, payload: data });
  } catch (error) {
    console.log(error);

    dispatch({
      type: FETCH_POST_FAILURE,
      payload: "Error fetching post",
    });
  }
};

export const deletePost = (postId: string) => async (dispatch: Dispatch) => {
  dispatch({ type: FETCH_POST_REQUEST });

  try {
    const { data } = await axios.delete(`/posts/${postId}`);
    dispatch({ type: FETCH_POST_SUCCESS, payload: data });
  } catch (error) {
    console.log(error);

    dispatch({
      type: FETCH_POST_FAILURE,
      payload: "Error fetching post",
    });
    throw error;
  }
};

export const fetchCategories = () => async (dispatch: Dispatch) => {
  try {
    dispatch({ type: FETCH_CATEGORIES_REQUEST });
    const response = await axios.get("/category/");
    dispatch({ type: FETCH_CATEGORIES_SUCCESS, payload: response.data });
    return response.data;
  } catch (error) {
    console.error("Error fetching categories:", error);
    dispatch({
      type: FETCH_CATEGORIES_FAILURE,
      payload: "Failed to fetch categories",
    });
    throw error;
  }
};

export const savePost =
  (post: IPost, postId?: string) => async (dispatch: Dispatch) => {
    dispatch({ type: SAVE_POST_REQUEST });

    try {
      const { data } = postId
        ? await axios.put(`/posts/${postId}`, post)
        : await axios.post("/posts", post);

      dispatch({ type: SAVE_POST_SUCCESS, payload: data });
    } catch (error) {
      console.log(error);

      dispatch({ type: SAVE_POST_FAILURE, payload: "Error saving post" });
      throw error;
    }
  };

export const clearPosts = () => ({ type: CLEAR_POSTS });
export const clearCurrentPost = () => ({ type: CLEAR_CURRENT_POST });

export const toggleLike = (postId: string) => async (dispatch: Dispatch) => {
  try {
    const { data } = await axios.post(`/posts/${postId}/like`);
    // Optimistically/actually update the post in the store
    // For simplicity, we just fetch it or let the component handle local state,
    // but the best way is to dispatch an update if the post is in the list
    dispatch({ type: FETCH_POST_SUCCESS, payload: data });
    return data;
  } catch (error) {
    console.error("Failed to toggle like", error);
    throw error;
  }
};
